import cookie from "js-cookie";
import axios from "axios";
import fetchUrl from "../../services/fetchUrl";
import { showSuccessSnackBar, showSnackBar } from "../Snackbar/snackbarActions";
import { FEEDBACK } from "../../services/constants";
import { getErrorMessage } from "../../services/utils";

export const sendAppLink = phone => {
  return dispatch => {
    axios({
      method: "post",
      url: fetchUrl("web", "sendapplink"),
      data: {
        phone: phone,
        type: "recruiter"
      },
      headers: {
        Authorization: cookie.get("rec_access_token"),
        source: "WEB"
      }
    })
      .then(() => {
        dispatch(
          showSuccessSnackBar(
            "Application link sent successfully on your mobile number!!"
          )
        );
      })
      .catch(error => {
        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(showSnackBar(errorMessage));
      });
  };
};

export const giveFeedback = (ratingText, ratingStar = null) => {
  return dispatch => {
    axios({
      method: "post",
      // url: fetchUrl("open", "feedback"),
      url: fetchUrl("recruiter", "set-app-feedback"),
      data: {
        rating_star: ratingStar || ratingStar == 0 ? ratingStar : undefined,
        rating_text: ratingText
      },
      headers: {
        Authorization: cookie.get("rec_access_token"),
        source: "WEB"
      }
    })
      .then(() => {
        dispatch(showSuccessSnackBar(FEEDBACK));
      })
      .catch(error => {
        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(showSnackBar(errorMessage));
      });
  };
};
